import { createRoot } from "react-dom/client";
import { App } from "@/app";
import "@/styles/globals.scss";

// Render once Office.js is ready (Outlook task pane).
// Falls back to immediate render when Office is unavailable (e.g. browser preview).
function mount(): void {
  const container = document.getElementById("container");
  if (container) {
    createRoot(container).render(<App />);
  }
}

if (typeof Office !== "undefined" && Office.onReady) {
  Office.onReady(() => mount());
} else {
  mount();
}
